import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlueButton from "./BlueButton";


export default function GoBackButton({ label = "Go Back" }) {
  const navigate = useNavigate();

  return (
    <BlueButton
      onClick={() => navigate(-1)}
      className="flex items-center gap-2"
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </BlueButton>
  );
}
